"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnChannelLeave = useOnChannelLeave;
var _react = require("react");
var _streamChatReact = require("stream-chat-react");
var _utils = require("../../../utils");
var _lodash = require("lodash");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function useOnChannelLeave(_ref) {
  var _ref$onSuccess = _ref.onSuccess,
    _onSuccess = _ref$onSuccess === void 0 ? _lodash.noop : _ref$onSuccess,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? _lodash.noop : _ref$onError;
  var _useChatContext = (0, _streamChatReact.useChatContext)(),
    client = _useChatContext.client,
    activeChannel = _useChatContext.channel,
    setActiveChannel = _useChatContext.setActiveChannel;
  var channels = (0, _lodash.values)((client === null || client === void 0 ? void 0 : client.activeChannels) || {});
  var onChannelLeft = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(channelId) {
      var isLeftActiveChannel, channel, updatedChannels, newActiveChannel, updatedChannel;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isLeftActiveChannel = activeChannel && activeChannel.id === channelId;
              if (isLeftActiveChannel) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              channel = (0, _lodash.find)(client.activeChannels, function (_ref3) {
                var id = _ref3.id;
                return id === channelId;
              });
              if (!(channel.type === _utils.SUPPORT_GROUP_CHANNEL_TYPES.GROUP_BOUND)) {
                _context.next = 10;
                break;
              }
              updatedChannels = channels.filter(function (channel) {
                return channel.id !== channelId;
              });
              newActiveChannel = (0, _lodash.find)(updatedChannels, function (ch) {
                return ch.type === _utils.SUPPORT_GROUP_CHANNEL_TYPES.GROUP_BOUND;
              }) || updatedChannels[0];
              setActiveChannel(newActiveChannel);
              _context.next = 14;
              break;
            case 10:
              _context.next = 12;
              return (0, _streamChatReact.getChannel)(client, channel.type, channel.id);
            case 12:
              updatedChannel = _context.sent;
              setActiveChannel(updatedChannel);
            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [client, activeChannel, channels]);
  var _useRequest = (0, _utils.useRequest)(function (channelId) {
      return {
        url: (0, _utils.getGroupChatUrl)(channelId),
        method: 'delete'
      };
    }, {
      manual: true,
      onSuccess: function () {
        var _onSuccess2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return onChannelLeft(data.channelId);
                case 2:
                  _onSuccess();
                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        function onSuccess(_x2) {
          return _onSuccess2.apply(this, arguments);
        }
        return onSuccess;
      }(),
      onError: onError
    }),
    loading = _useRequest.loading,
    leaveChat = _useRequest.run;

  // we need this separate handler to pass it to ChannelList and be able to update channels
  // with setChannels capback passed as handler argument
  // this callback is called by stream in response to notification.removed_from_channel event
  var onRemovedFromChannel = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(setChannels, event) {
      var channelType, channelId, updatedChannel;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              channelType = event.channel.type;
              channelId = event.channel.id;
              if (!(channelType === _utils.SUPPORT_GROUP_CHANNEL_TYPES.GROUP_BOUND)) {
                _context3.next = 6;
                break;
              }
              setChannels(function (channels) {
                var updatedChannels = channels.filter(function (channel) {
                  var _event$channel;
                  return channel.cid !== ((_event$channel = event.channel) === null || _event$channel === void 0 ? void 0 : _event$channel.cid);
                });
                return updatedChannels;
              });
              _context3.next = 10;
              break;
            case 6:
              _context3.next = 8;
              return (0, _streamChatReact.getChannel)(client, channelType, channelId);
            case 8:
              updatedChannel = _context3.sent;
              setChannels(function (channels) {
                return channels.map(function (ch) {
                  return ch.id === channelId ? updatedChannel : ch;
                });
              });
            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function (_x3, _x4) {
      return _ref4.apply(this, arguments);
    };
  }(), [client]);
  return {
    leaveChat: leaveChat,
    loading: loading,
    onRemovedFromChannel: onRemovedFromChannel
  };
}